import { Component } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { formatDate, formatTime } from '../../constant/dateTime';

// mui icons
import MotorcycleIcon from '@material-ui/icons/Motorcycle';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import riderIcon from '../../../images/rider-icon.png';

import '../Map/Map.css';

class Map extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        const myLatLng = { lat: this.props.lati, lng: this.props.longi };
        const map = new window.google.maps.Map(document.getElementById('map'), {
            center: myLatLng,
            zoom: 17
        });

        const marker = new window.google.maps.Marker({
            position: myLatLng,
            map: map,
            icon: riderIcon
        });

        const infowindow = new window.google.maps.InfoWindow({
            content: "<p>Name: " + this.props.riderName + "</p>",
        });
    
        new window.google.maps.event.addListener(marker, "click", () => {
            infowindow.open(map, marker);
        });
    }

    render () {
        return (
            <>
                <Grid 
                    container 
                    spacing={1}
                    direction="row"
                    style={{margin: "45px auto 0", paddingBottom: "15px"}}
                    className="details__row--status"
                    >
                    <Grid item xs={12} sm={9} md={9} lg={9}>
                        <Grid container direction="row" nowrap="true">
                            <Grid item xs={2} sm={1}>
                                <CheckCircleRoundedIcon className="CheckCircleRoundedIcon" />
                            </Grid>    
                            <Grid item xs={10} sm={11}>
                                <Typography component="h1" variant="h5" style={{ textAlign: "left" }}>
                                    Document is being delivered
                                </Typography>
                                <Typography variant="body1">
                                    Our rider will attempt to deliver your document today! Please keep your lines open so our rider can contact you. If you are not available, 
                                    please have an authorized representative to receive on your behalf.
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={3} md={3} lg={3}>
                        <Grid container direction="row" nowrap="true">
                            <Grid item xs={2} sm={1}></Grid>
                            <Grid item xs={10} sm={11}>
                                <Typography component="h1" variant="h6">
                                    {formatDate(this.props.date)}
                                </Typography>
                                <Typography variant="body1" gutterBottom>
                                    {formatTime(this.props.time)}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <div id="map"></div>

                <Grid container direction="row" className="details__row border__line block__map--details clearfix">
                    <Grid item xs={6} md={6} lg={6} className="float-left">
                        <Typography component="h1" variant="h5">
                            <MotorcycleIcon className="MotorcycleIcon" /> Your driver is on the way.
                        </Typography>
                    </Grid>
                    <Grid item xs={6}  md={6} lg={6} className="float-left right__details">
                        <Typography component="h1" variant="h5">
                            Status: {this.props.resStatus}
                        </Typography>
                        <Typography component="h1" variant="h5">
                            Delivery By: {this.props.riderName}
                        </Typography>
                    </Grid>
                </Grid>
            </>
        )
    }
}

export default Map;